module.exports = __webpack_public_path__ + "static/img/ap5.dcf7525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap5.jpg
// module id = 54j3
// module chunks = 1